import { RouteConfig } from 'vue-router';
import ConsultaObras from '../ConsultaObras.vue';
import VisualizaRelatorio from '../DetalhesObra.vue';
const baseRouterLink = '/obras';

const ConsultaObrasRoutes: RouteConfig[] = [
  {
    path: `${baseRouterLink}/consulta`,
    name: 'consulta-obras',
    component: ConsultaObras,
  },
  {
    path: `${baseRouterLink}/visualiza/:cdObra/:cdTipoObra`,
    name: 'visualiza-obras',
    component: VisualizaRelatorio,
  },
];

export default ConsultaObrasRoutes;
